import { MODIFY_WORKFLOW, RESET_WORKFLOW } from '../types';

const initialState = () => ({
  workflow: {},
});

export default (state = initialState, action) => {
  let newState = {};

  switch (action.type) {
    case MODIFY_WORKFLOW:
      newState = { workflow: action.payload };
      break;
    default:
      newState = {};
  }

  return action.type === RESET_WORKFLOW
    ? initialState()
    : {
      ...state,
      ...newState,
    };
};
export const getWorkflow = (state) => state.workflowReducer.workflow;
